import apiUseCases from "@src/cloud-connect/api";
import { MachineWithSkills } from "@src/cloud-connect/api/client-configuration/get-machines-with-skills";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";

export const getMachinesWithSkillsUseCase = async (): Promise<{
  success: boolean;
  data?: MachineWithSkills[];
  error?: string;
}> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;
    const response = await apiUseCases.getMachinesWithSkills(namespace);

    return { success: true, data: response.machines };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(error, "Failed to fetch machines and skills.")
        .message,
    };
  }
};
